/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, OnInit } from '@angular/core';

import { ProviderGroupService } from '../../services/provider/provider-group.service';

@Component({
  selector: 'app-recipientinfo',
  templateUrl: './recipientinfo.component.html',
  styleUrls: ['./recipientinfo.component.css'],
})
export class RecipientinfoComponent implements OnInit {
  @Input() providerGroupId: string;
  recipientInfo: any;

  constructor(private recipientInfoService: ProviderGroupService) {}

  ngOnInit(): void {
    setTimeout(() => {
      //console.log('recipient info: ' + this.providerGroupId);
      if (this.providerGroupId) {
        this.recipientInfoService
          .getProviderGroupByGroupId(this.providerGroupId)
          .subscribe((data) => {
            this.recipientInfo = data;
          });
      }
    }, 300);
  }
}
